import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PinnaklModalComponent } from '../../pinnakl-modal';
import { ReconnectWindowService } from './reconnect-window.service';

@Component({
  selector: 'reconnect-window',
  imports: [PinnaklModalComponent],
  providers: [ReconnectWindowService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'reconnect-window.component.html',
})
export class ReconnectWindowComponent {
  reconnectWindowService = inject(ReconnectWindowService);
}
